/**
 * Configuration Centrale pour le Token Baobab (BBT)
 * 
 * Ce fichier contient toutes les informations critiques et constantes
 * liées au token BBT déployé sur le Mainnet.
 * Utiliser ce fichier comme unique source de vérité pour tout ce qui concerne BBT.
 */

// 1. Informations du Contrat Principal
export const BBT_CONTRACT_ADDRESS = "0x0354a58290E141b241d5b32AE02D581289f286b7";
export const BBT_CONTRACT_NETWORK_ID = 56; // 56 pour BSC Mainnet, 97 pour Testnet
export const BBT_CONTRACT_NETWORK_NAME = "Binance Smart Chain Mainnet";
export const BBT_SYMBOL = "BBT";
export const BBT_DECIMALS = 18;

// 2. Informations de Liquidité (PancakeSwap v2)
export const BBT_BNB_LP_ADDRESS = "0x92AC19404DB9b4d5d841dBCa2d53fBb97eeCC146";
export const PANCAKESWAP_ROUTER_ADDRESS = "0x10ED43C718714eb63d5aA57B78B54704E256024E";

// 3. Liens Officiels
export const BSC_SCAN_URL = `https://bscscan.com/token/${BBT_CONTRACT_ADDRESS}`;
export const PANCAKESWAP_SWAP_URL = `https://pancakeswap.finance/swap?outputCurrency=${BBT_CONTRACT_ADDRESS}`;
export const DEXSCREENER_URL = `https://dexscreener.com/bsc/${BBT_BNB_LP_ADDRESS}`;
export const DEXTOOLS_URL = `https://www.dextools.io/app/bsc/pair-explorer/${BBT_BNB_LP_ADDRESS}`;

// NOUVEAU: Objet de configuration centralisé qui regroupe les URLs
export const BBT_CONFIG = {
  urls: {
    bscScan: BSC_SCAN_URL,
    pancakeSwap: PANCAKESWAP_SWAP_URL,
    dexScreener: DEXSCREENER_URL,
    dexTools: DEXTOOLS_URL,
    // Ajoutez ici d'autres liens si nécessaire
  },
  // ... (d'autres configurations globales peuvent être ajoutées ici)
};

// 4. ABI (Application Binary Interface) Partiel
// Uniquement les fonctions les plus utilisées pour alléger le poids.
// L'ABI complet peut être stocké ailleurs si nécessaire.
export const BBT_ABI_MINIMAL = [
  // --- Fonctions de lecture (view) ---
  "function name() view returns (string)",
  "function symbol() view returns (string)",
  "function decimals() view returns (uint8)",
  "function totalSupply() view returns (uint256)",
  "function balanceOf(address account) view returns (uint256)",
  "function allowance(address owner, address spender) view returns (uint256)",
  
  // --- Fonctions d'écriture (transactions) ---
  "function transfer(address recipient, uint256 amount) returns (bool)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function transferFrom(address sender, address recipient, uint256 amount) returns (bool)",
  "function burn(uint256 amount)",

  // --- Événements ---
  "event Transfer(address indexed from, address indexed to, uint256 value)",
  "event Approval(address indexed owner, address indexed spender, uint256 value)",
  "event TokensBurned(address indexed from, uint256 amount)"
];

// 5. Métadonnées pour l'ajout à MetaMask
export const METAMASK_ASSET_INFO = {
  address: BBT_CONTRACT_ADDRESS,
  symbol: BBT_SYMBOL,
  decimals: BBT_DECIMALS,
  // Assurez-vous que cette image est accessible publiquement via votre domaine
  image: `https://www.baobabexchange.com/images/tokens/bbt-token.svg`,
}; 